import Vue from "vue";
import Router from "vue-router";

import { IsEnterprise, IsAdmin, IsProject, GetUserByToken } from "@/setAxios";
import store from "@/store";

Vue.use(Router);
const login = () => import("@/views/login");

const exam = () => import("@/views/exam");

const dome = () => import("@/views/dome");

const viewModel = () => import("@/views/viewModel");
const viewFileModel = () => import("@/views/viewFileModel");
const viewMyDocument = () => import("@/views/viewMyDocument");

// 这里是超管
const admin = () => import("@/views/admin/admin");
const adminAnnouncement = () => import("@/views/admin/announcement");
const adminEnterprise = () => import("@/views/admin/enterprise");
const adminProjectSheet = () => import("@/views/admin/adminProjectSheet");
const adminPropaganda = () => import("@/views/admin/propaganda");
const loginInfo = () => import("@/views/admin/loginInfo");
const adminUser = () => import("@/views/admin/user");
const corporateBigData = () => import("@/views/admin/corporateBigData");
const projectBigData = () => import("@/views/admin/projectBigData");
const userBigData = () => import("@/views/admin/userBigData");
const modelManager = () => import("@/views/admin/modelManager");
const enterpriseDataView = () => import("@/views/admin/enterpriseDataView");
const modelFunction = () => import("@/views/admin/modelFunction");
// 这里是企管
const enterprise = () => import("@/views/enterprise/enterprise");
const enterpriseIndex = () => import("@/views/enterprise/enterpriseIndex");
const control = () => import("@/views/enterprise/control");
const enterpriseProject = () => import("@/views/enterprise/enterpriseProject");
// 项目报表
const projectSheet = () => import("@/views/enterprise/projectSheet");
const enterpriseModelManagement = () =>
  import("@/views/enterprise/enterpriseModelManagement");
const operationInfo = () => import("@/views/enterprise/operationInfo");
const enterpriseManagement = () =>
  import("@/views/enterprise/enterpriseManagement");
const enterpriseDept = () => import("@/views/enterprise/enterpriseDept");
const enterprisePersonnel = () =>
  import("@/views/enterprise/enterprisePersonnel");
const smartBigData = () => import("@/views/enterprise/smartBigData");

// 这是项管

const projectControl = () => import("@/views/project/projectControl");
// 这里是项目设置
const projectInformation = () =>
  import("@/views/project/ProjectSettings/CreateProject/ProjectInformation");
const JobPage = () =>
  import("@/views/project/ProjectSettings/CreateProject/JobPage");
const SessionPage = () =>
  import("@/views/project/ProjectSettings/CreateProject/SessionPage");
const InformManagement = () =>
  import("@/views/project/ProjectSettings/CreateProject/InformManagement");
// 团队配置
const organization = () =>
  import("@/views/project/ProjectSettings/teamConfiguration/organization");
const PostPermissions = () =>
  import("@/views/project/ProjectSettings/teamConfiguration/PostPermissions");
const userManagement = () =>
  import("@/views/project/ProjectSettings/teamConfiguration/userManagement");
const weiboLabel = () =>
  import("@/views/project/ProjectSettings/teamConfiguration/weiboLabel");
//协作设置
const singleSet = () =>
  import("@/views/project/ProjectSettings/setCollaboration/singleSet");

const formTemplate = () =>
  import("@/views/project/ProjectSettings/flowChart/formTemplate");
const chartFlow = () =>
  import("@/views/project/ProjectSettings/flowChart/chartFlow");

// 项目立项
const flowLayout = () =>
  import("@/views/project/ProjectSettings/projectInitiation/flowLayout");
const modelConfigure = () =>
  import("@/views/project/ProjectSettings/projectInitiation/modelConfigure");
const dataQuery = () =>
  import("@/views/project/ProjectSettings/projectInitiation/dataQuery");

const topic = () =>
  import("@/views/project/ProjectSettings/setCollaboration/topic");
// 指令设置
const instructionSet = () =>
  import("@/views/project/ProjectSettings/instructionSet/instructionSet");
// 这里是综合管理设置
const coordinate = () =>
  import("@/views/project/ProjectSettings/IntegratedManagement/coordinate");
const ContactList = () =>
  import("@/views/project/ProjectSettings/IntegratedManagement/ContactList");
// 物资管理
const Material = () =>
  import("@/views/project/ProjectSettings/Material/Material");
// 安全交底配置
const security = () =>
  import("@/views/project/ProjectSettings/security/security");
// 施工交底配置
const construction = () =>
  import("@/views/project/ProjectSettings/Quality/construction");
// 进度管理设置
const Schedule = () =>
  import("@/views/project/ProjectSettings/Schedule/Schedule");
//进度展示状态
const progressShowState =()=>
import("@/views/project/ProjectSettings/Schedule/progressShowState");

// 资料目录配置
const dataDirectory = () =>
  import("@/views/project/ProjectSettings/DataSetting/dataDirectory");



// 图纸目录配置
const Drawings = () =>
  import("@/views/project/ProjectSettings/DataSetting/Drawings");

// 模板配置
const template = () =>
  import("@/views/project/ProjectSettings/barCode/template");
// 标签设置
const tagSetting = () =>
  import("@/views/project/ProjectSettings/live/tagSetting");

// 预定义审核流程
const predefinedAuditProcess = () =>
  import("@/views/project/ProjectSettings/DataSetting/predefinedAuditProcess");

// 用户
const userViewModel = () => import("@/views/user/userViewModel");
const userViewModelIfram = () => import("@/views/user/userViewModelIfram");
// 模型会话
const modelSession = () => import("@/views/user/modelSession");
const modelSessionIfram = () => import("@/views/user/modelSessionIfram");
// 视频会议
const videoConference = () => import("@/views/user/videoConference");
// 项目看板
const projectBoard = () => import("@/views/user/projectBoard");
// 这是用户应用导航
const userControl = () => import("@/views/user/userControl");
// 这里是项目用户主页
const userProjectIndex = () => import("@/views/user/userProjectIndex");
// 团队成员
// 通讯目录
const communication = () => import("@/views/user/teamUser/communication");
// 工程动态
const weibo = () => import("@/views/user/teamUser/weibo");
// 协作沟通
// 工单任务
const workOrder = () => import("@/views/user/collaboration/workOrder");
// 同屏会话
const session = () => import("@/views/user/collaboration/session");
// 话题讨论
const discussTheTopic = () =>
  import("@/views/user/collaboration/discussTheTopic");
// 属性管理
const propertyManagement = () =>
  import("@/views/user/collaboration/propertyManagement");

//综合管理

// 计划发布
const PlansToRelease = () =>
  import("@/views/user/planManagement/PlansToRelease");
// 计划监控
const PlanToMonitor = () => import("@/views/user/planManagement/PlanToMonitor");
// 我的任务
const myTask = () => import("@/views/user/planManagement/myTask");
// 模型评审
const modelEvaluation = () =>
  import("@/views/user/planManagement/modelEvaluation");
// 计划详情
const plansDetails = () => import("@/views/user/planManagement/plansDetails");

// 设计协调
const designCoordination = () =>
  import("@/views/user/integratedManagement/designCoordination");
// 工程联系单
const contactSheet = () =>
  import("@/views/user/integratedManagement/contactSheet");
// 安全管理
// 安全交底
const safetyDisclosure = () => import("@/views/user/security/safetyDisclosure");
// 质量管理
// 施工交底
const roadWork = () => import("@/views/user/qualityManagement/roadWork");
// 进度管理
// 进度计划
const progressPlan = () => import("@/views/user/schedule/progressPlan");
// 施工进度计划
const constructionSchedule = () =>
  import("@/views/user/schedule/constructionSchedule");
// 三维模拟
const simulation = () => import("@/views/user/schedule/simulation");
//进度展示
const progressShow = () => import("@/views/user/schedule/progressShow");
// 资料管理
// 资料列表
const dataList = () => import("@/views/user/dataManagement/dataList");
const annotationList = () => import("@/views/user/dataManagement/annotationList");
const myData = () => import("@/views/user/dataManagement/myData");
const auditData = () => import("@/views/user/dataManagement/auditData");
// 图纸列表
const DrawingsList = () => import("@/views/user/dataManagement/DrawingsList");
// 任务后资料
const afterTheTask = () => import("@/views/user/dataManagement/afterTheTask");
// 构建关联
const associated = () => import("@/views/user/dataManagement/associated");
// 条码管理
// 条码点位
const location = () => import("@/views/user/barCode/location");
const locationModel = () => import("@/views/user/barCode/locationModel");
// 条码列表
const barCodeList = () => import("@/views/user/barCode/barCodeList");
// 实景管理
// 实景点位
const liveBarCode = () => import("@/views/user/live/liveBarCode");
const liveBarCodeModel = () => import("@/views/user/live/liveBarCodeModel");
const liveLabel = () => import("@/views/user/liveLabel");
// 实景列表
const liveList = () => import("@/views/user/live/liveList");

// 话题讨论
const discussTheTopicModel = () =>
  import("@/views/user/collaboration/discussTheTopicModel");
// 属性管理
const propertyManagementModel = () =>
  import("@/views/user/collaboration/propertyManagementModel");

const topicTaolun = () => import("@/views/user/collaboration/topicTaolun");

// 日程安排
const dateSet = () => import("@/views/user/dateSet");

// s三维进度模型
const simulationModel = () => import("@/views/user/schedule/simulationModel");

// 形象进度model
const trueProgressModel = () =>
  import("@/views/user/schedule/trueProgressModel");

// 形象进度
const trueProgress = () => import("@/views/user/schedule/trueProgress");

// 同屏会话
const screenTic = () => import("@/views/user/screenTic");

const zhangjiang = () => import("@/views/dataView/mapView");

const sichuan = () => import("@/views/dataView/sichuan");

// 模型比对
const ModelCompare = () => import("@/views/ModelCompare");
const appModelView = () => import("@/views/appModelView");

const appDocumentShow = () => import("@/views/appDocumentShow");

const appDrawingShow = () => import("@/views/appDrawingShow");

// 操作手册

const adminHelp = () => import("@/views/operationManual/adminHelp");
const enterpriseHelp = () => import("@/views/operationManual/enterpriseHelp");

const mobileHelp = () => import("@/views/operationManual/mobileHelp");
const userHelp = () => import("@/views/operationManual/userHelp");

const projectHelp = () => import("@/views/operationManual/projectHelp");
const userFlowChart = () => import("@/views/user/collaboration/userFlowChart");



const router = new Router({
  // mode: "history",
  // base: process.env.BASE_URL,
  routes: [
    // PC端
    {
      path: "/login",
      name: "login",
      component: login,
    },
    {
      path: "/appModelView",
      name: "appModelView",
      component: appModelView,
    },
    {
      path: "/appDocumentShow",
      name: "appDocumentShow",
      component: appDocumentShow,
    },
    {
      path: "/appDrawingShow",
      name: "appDrawingShow",
      component: appDrawingShow,
    },
    {
      path: "/projectBoard",
      name: "projectBoard",
      component: projectBoard,
    },
    {
      path: "/enterpriseDataView",
      name: "enterpriseDataView",
      component: enterpriseDataView,
    },
    {
      path: "/ModelCompare",
      name: "ModelCompare",
      component: ModelCompare,
    },
    {
      path: "/zj",
      name: "zhangjiang",
      component: zhangjiang,
    },
    {
      path: "/sc",
      name: "sichuan",
      component: sichuan,
    },
    {
      path: "/screenTic",
      name: "screenTic",
      component: screenTic,
    },
    {
      path: "/liveLabel",
      name: "liveLabel",
      component: liveLabel,
    },
    {
      path: "/dome",
      name: "dome",
      component: dome,
    },
    {
      path: "/simulationModel",
      name: "simulationModel",
      component: simulationModel,
    },
    {
      path: "/trueProgressModel",
      name: "trueProgressModel",
      component: trueProgressModel,
    },
    {
      path: "/dateSet",
      name: "dateSet",
      component: dateSet,
    },
    {
      path: "/topicTaolun",
      name: "topicTaolun",
      component: topicTaolun,
    },
    {
      path: "/discussTheTopicModel",
      name: "discussTheTopicModel",
      component: discussTheTopicModel,
    },
    {
      path: "/propertyManagementModel",
      name: "propertyManagementModel",
      component: propertyManagementModel,
    },
    {
      path: "/locationModel",
      name: "locationModel",
      component: locationModel,
    },
    {
      path: "/userViewModelIfram",
      name: "userViewModelIfram",
      component: userViewModelIfram,
    },
    {
      path: "/modelSessionIfram",
      name: "modelSessionIfram",
      component: modelSessionIfram,
    },
    {
      path: "/liveBarCodeModel",
      name: "liveBarCodeModel",
      component: liveBarCodeModel,
    },
    {
      path: "/",
      redirect: "/enterprise",
    },
    {
      path: "/viewModel",
      name: "viewModel",
      component: viewModel,
    },
  {
      path: "/viewFileModel",
      name: "viewFileModel",
      component: viewFileModel,
    },
    {
      path: "/viewMyDocument",
      name: "viewMyDocument",
      component: viewMyDocument,
    },
    // 这里是尚未开发的
    {
      path: "/exam",
      name: "exam",
      component: exam,
    },
    // 用户大数据
    {
      path: "/userBigData",
      name: "userBigData",
      component: userBigData,
    },
    // 企业大数据
    {
      path: "/corporateBigData",
      name: "corporateBigData",
      component: corporateBigData,
    },
    // 项目大数据
    {
      path: "/projectBigData",
      name: "projectBigData",
      component: projectBigData,
    },
    // 这里是超管
    {
      path: "/admin",
      component: admin,
      children: [
        {
          path: "/",
          redirect: "/adminUser",
        },
        {
          path: "/adminAnnouncement",
          name: "announcement",
          component: adminAnnouncement,
        },
        {
          path: "/adminEnterprise",
          name: "adminEnterprise",
          component: adminEnterprise,
        },
        {
          path: "/adminProjectSheet",
          name: "adminProjectSheet",
          component: adminProjectSheet,
        },
        {
          path: "/adminPropaganda",
          name: "propaganda",
          component: adminPropaganda,
        },
        {
          path: "/modelManager",
          name: "modelManager",
          component: modelManager,
        },
        {
          path: "/loginInfo",
          name: "loginInfo",
          component: loginInfo,
        },
        {
          path: "/adminUser",
          name: "adminUser",
          component: adminUser,
        },

        {
          path: "/adminHelp",
          name: "adminHelp",
          component: adminHelp,
        },
        {
          path: "/enterpriseHelp",
          name: "enterpriseHelp",
          component: enterpriseHelp,
        },
        {
          path: "/mobileHelp",
          name: "mobileHelp",
          component: mobileHelp,
        },
        {
          path: "/userHelp",
          name: "userHelp",
          component: userHelp,
        },
        {
          path: "/projectHelp",
          name: "projectHelp",
          component: projectHelp,
        },
        {
          path: "/modelFunction",
          name: "modelFunction",
          component: modelFunction,
        },
      ],
    },
    // 这里是头部和主页
    {
      path: "/enterprise",
      component: enterprise,
      children: [
        {
          path: "/",
          redirect: "/enterpriseIndex",
        },
        {
          path: "/enterpriseIndex",
          name: "enterpriseIndex",
          component: enterpriseIndex,
        },
        // 这是企管
        {
          path: "/control",
          component: control,
          redirect: "/enterpriseManagement",
          children: [
            {
              path: "/enterpriseProject",
              name: "enterpriseProject",
              component: enterpriseProject,
            },
            {
              path: "/projectSheet",
              name: "projectSheet",
              component: projectSheet,
            },
            {
              path: "/enterpriseModelManagement",
              name: "enterpriseModelManagement",
              component: enterpriseModelManagement,
            },
            {
              path: "/operationInfo",
              name: "operationInfo",
              component: operationInfo,
            },
            {
              path: "/enterpriseManagement",
              name: "enterpriseManagement",
              component: enterpriseManagement,
            },
            {
              path: "/enterpriseDept",
              name: "enterpriseDept",
              component: enterpriseDept,
            },
            {
              path: "/enterprisePersonnel",
              name: "enterprisePersonnel",
              component: enterprisePersonnel,
            },
          ],
        },
        // 这是项目管理
        {
          path: "/projectControl",
          component: projectControl,
          redirect: "/ProjectInformation",
          children: [
            // 这里是项目立项
            {
              path: "/ProjectInformation",
              name: "projectInformation",
              component: projectInformation,
            },
            {
              path: "/ProjectMenuTemplate",
              name: "ProjectMenuTemplate",
              component: () => import("@/views/user/Menu_6/MenuTemplate"),
            },
            {
              path: "/JobPage",
              name: "JobPage",
              component: JobPage,
            },

            {
              path: "/SessionPage",
              name: "SessionPage",
              component: SessionPage,
            },
            {
              path: "/InformManagement",
              name: "InformManagement",
              component: InformManagement,
            },
            // 团队配置
            {
              path: "/organization",
              name: "organization",
              component: organization,
            },
            {
              path: "/PostPermissions",
              name: "PostPermissions",
              component: PostPermissions,
            },
            {
              path: "/userManagement",
              name: "userManagement",
              component: userManagement,
            },
            {
              path: "/weiboLabel",
              name: "weiboLabel",
              component: weiboLabel,
            },
            // 协作配置
            {
              path: "/singleSet",
              name: "singleSet",
              component: singleSet,
            },
            {
              path: "/formTemplate",
              name: "formTemplate",
              component: formTemplate,
            },
            {
              path: "/chartFlow",
              name: "chartFlow",
              component: chartFlow,
            },
            {
              path: "/topic",
              name: "topic",
              component: topic,
            },
            // 指令设置
            {
              path: "/instructionSet",
              name: "instructionSet",
              component: instructionSet,
            },
            // 综合管理
            {
              path: "/coordinate",
              name: "coordinate",
              component: coordinate,
            },
            {
              path: "/ContactList",
              name: "ContactList",
              component: ContactList,
            },
            // 物资管理
            {
              path: "/Material",
              name: "Material",
              component: Material,
            },
            //安全交底配置
            {
              path: "/security",
              name: "security",
              component: security,
            },
            // 施工交底配置
            {
              path: "/construction",
              name: "construction",
              component: construction,
            },
            // 进度管理
            {
              path: "/Schedule",
              name: "Schedule",
              component: Schedule,
            },
            {
              path: "/progressShowState",
              name: "progressShowState",
              component: progressShowState,
            },
            // 资料目录配置
            {
              path: "/dataDirectory",
              name: "dataDirectory",
              component: dataDirectory,
            },
            // 图纸目录配置 Drawings
            {
              path: "/Drawings",
              name: "Drawings",
              component: Drawings,
            },
            {
              path: "/predefinedAuditProcess",
              name: "predefinedAuditProcess",
              component: predefinedAuditProcess,
            },
            // 模板设置
            {
              path: "/template",
              name: "template",
              component: template,
            },
            // 标签配置
            {
              path: "/tagSetting",
              name: "tagSetting",
              component: tagSetting,
            },
            {
              path: "/flowLayout",
              name: "flowLayout",
              component: flowLayout,
            },
            {
              path: "/modelConfigure",
              name: "modelConfigure",
              component: modelConfigure,
            },
            {
              path: "/dataQuery",
              name: "dataQuery",
              component: dataQuery,
            },
          ],
        },
        // 这是用户
        {
          path: "/userControl",
          component: userControl,
          redirect: "/userProjectIndex",
          children: [
            {
              path: "/userProjectIndex",
              name: "userProjectIndex",
              component: userProjectIndex,
            },
            {
              path: "/DataBoard",
              name: "DataBoard",
              component: () => import("@/views/user/DataBoard/DataBoard"),
            },
            {
              path: "/PlansToRelease",
              name: "PlansToRelease",
              component: PlansToRelease,
            },
            {
              path: "/PlanToMonitor",
              name: "PlanToMonitor",
              component: PlanToMonitor,
            },
            {
              path: "/myTask",
              name: "myTask",
              component: myTask,
            },
            {
              path: "/modelEvaluation",
              name: "modelEvaluation",
              component: modelEvaluation,
            },
            {
              path: "/plansDetails",
              name: "plansDetails",
              component: plansDetails,
            },
            {
              path: "/userViewModel",
              name: "userViewModel",
              component: userViewModel,
            },
            {
              path: "/modelSession",
              name: "modelSession",
              component: modelSession,
            },
            {
              path: "/videoConference",
              name: "videoConference",
              component: videoConference,
            },
            // 通讯目录
            {
              path: "/communication",
              name: "communication",
              component: communication,
            },
            // 工程动态
            {
              path: "/weibo",
              name: "weibo",
              component: weibo,
            },
            // 工单任务
            {
              path: "/workOrder",
              name: "workOrder",
              component: workOrder,
            },

            {
              path: "/userFlowChart",
              name: "userFlowChart",
              component: userFlowChart,
            },

            // 同屏会话
            {
              path: "/session",
              name: "session",
              component: session,
            },
            // 话题讨论
            {
              path: "/discussTheTopic",
              name: "discussTheTopic",
              component: discussTheTopic,
            },
            {
              path: "/propertyManagement",
              name: "propertyManagement",
              component: propertyManagement,
            },
            // 设计协调
            {
              path: "/designCoordination",
              name: "designCoordination",
              component: designCoordination,
            },
            // 工程联系单
            {
              path: "/contactSheet",
              name: "contactSheet",
              component: contactSheet,
            },
            // 安全交底
            {
              path: "/safetyDisclosure",
              name: "safetyDisclosure",
              component: safetyDisclosure,
            },
            // 施工交底
            {
              path: "/roadWork",
              name: "roadWork",
              component: roadWork,
            },
            // 进度计划
            {
              path: "/progressPlan",
              name: "progressPlan",
              component: progressPlan,
            },
            // 进度监控
            {
              path: "/MonitoringProgress",
              name: "MonitoringProgress",
              component: () =>
                import("@/views/user/MonitoringProgress/MonitoringProgress"),
            },
            {
              path: "/constructionSchedule",
              name: "constructionSchedule",
              component: constructionSchedule,
            },
            // 三维模拟
            {
              path: "/simulation",
              name: "simulation",
              component: simulation,
            },
            {
              path: "/trueProgress",
              name: "trueProgress",
              component: trueProgress,
            },
            {
              path: "/progressShow",
              name: "progressShow",
              component: progressShow,
            },
            // 资料列表
            {
              path: "/dataList",
              name: "dataList",
              component: dataList,
            },
            // 批注列表
            {
              path: "/annotationList",
              name: "annotationList",
              component: annotationList,
            },
            {
              path: "/myData",
              name: "myData",
              component: myData,
            },
            {
              path: "/auditData",
              name: "auditData",
              component: auditData,
            },
            // 图纸列表
            {
              path: "/DrawingsList",
              name: "DrawingsList",
              component: DrawingsList,
            },
            // 任务后资料
            {
              path: "/afterTheTask",
              name: "afterTheTask",
              component: afterTheTask,
            },
            // 构建关联
            {
              path: "/associated",
              name: "associated",
              component: associated,
            },
            // 条码点位
            {
              path: "/location",
              name: "location",
              component: location,
            },
            // 条码列表barCodeList
            {
              path: "/barCodeList",
              name: "barCodeList",
              component: barCodeList,
            },
            // 实景点位
            {
              path: "/liveBarCode",
              name: "liveBarCode",
              component: liveBarCode,
            },
            // 实景列表
            {
              path: "/liveList",
              name: "liveList",
              component: liveList,
            },
            //6.0 菜单
            {
              path: "/MenuTemplate",
              name: "MenuTemplate",
              component: () => import("@/views/user/Menu_6/MenuTemplate"),
            },
            //项目立项
            //项目评估——地质灾害
            {
              path: "/xm_pg_dz",
              name: "xm_pg_dz",
              meta: { name: "地质灾害" },
              component: () =>
                import("@/views/user/Menu_6/xmlx/assess/xm_pg_dz/xm_pg_dz"),
            },
            {
              path: "/xm_pg_SeismicSafety",
              name: "xm_pg_SeismicSafety",
              meta: { name: "地震安全" },
              component: () =>
                import(
                  "@/views/user/Menu_6/xmlx/assess/xm_pg_SeismicSafety/xm_pg_SeismicSafety"
                ),
            },
            {
              path: "/xm_pg_environment",
              name: "xm_pg_environment",
              meta: { name: "环境影响" },
              component: () =>
                import(
                  "@/views/user/Menu_6/xmlx/assess/xm_pg_environment/xm_pg_environment"
                ),
            },
            {
              path: "/xm_pg_WaterSaving",
              name: "xm_pg_WaterSaving",
              meta: { name: "用水节水" },
              component: () =>
                import(
                  "@/views/user/Menu_6/xmlx/assess/xm_pg_WaterSaving/xm_pg_WaterSaving"
                ),
            },
            {
              path: "/xm_pg_traffic",
              name: "xm_pg_traffic",
              meta: { name: "交通影响" },
              component: () =>
                import(
                  "@/views/user/Menu_6/xmlx/assess/xm_pg_Traffic/xm_pg_Traffic"
                ),
            },
            //项目评估End=====
            {
              path: "/proposal",
              name: "proposal",
              meta: { name: "项目建议书" },
              component: () =>
                import("@/views/user/Menu_6/xmlx/proposal/proposal"),
            },
            {
              path: "/feasibilityResearch",
              name: "feasibilityResearch",
              meta: { name: "可行性研究" },
              component: () =>
                import(
                  "@/views/user/Menu_6/xmlx/feasibilityResearch/feasibilityResearch"
                ),
            },
            {
              path: "/investment",
              name: "investment",
              meta: { name: "项目投资估算" },
              component: () =>
                import("@/views/user/Menu_6/xmlx/investment/investment"),
            },
            {
              path: "/design_preliminary",
              name: "design_preliminary",
              meta: { name: "初步设计概算" },
              component: () =>
                import(
                  "@/views/user/Menu_6/xmlx/design/design_preliminary/design_preliminary"
                ),
            },
            {
              path: "/design_earthwork",
              name: "design_earthwork",
              meta: { name: "土方保持设计" },
              component: () =>
                import(
                  "@/views/user/Menu_6/xmlx/design/design_earthwork/design_earthwork"
                ),
            },
            {
              path: "/pipelineDetect",
              name: "pipelineDetect",
              meta: { name: "地下管线和探测" },
              component: () =>
                import(
                  "@/views/user/Menu_6/xmlx/exploration/pipelineDetect/pipelineDetect"
                ),
            },
            {
              path: "/prospecting",
              name: "prospecting",
              meta: { name: "勘探和物探" },
              component: () =>
                import(
                  "@/views/user/Menu_6/xmlx/exploration/prospecting/prospecting"
                ),
            },
            {
              path: "/ConstructionText",
              name: "ConstructionText",
              meta: { name: "施工图文审查" },
              component: () =>
                import(
                  "@/views/user/Menu_6/xmlx/ConstructionText/ConstructionText"
                ),
            },
          ],
        },
      ],
    },
    //智慧大数据
    {
      path: "/smartBigData",
      name: "smartBigData",
      component: smartBigData,
    },
    // 这里是404故障出错页面
    {
      path: "/error404",
      name: "error404",
      component: () => import("@/views/error404"),
    },
  ],
});

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

let routerList = router.options.routes.map((res) => {
  return res.path;
});

// 路由守卫
export const adminRoute = [
  "adminuser",
  "adminenterprise",
  "adminprojectsheet",
  "modelmanager",
  "adminannouncement",
  "adminpropaganda",
  "enterprisedataview",
  "logininfo",
  "adminhelp",
  "enterprisehelp",
  "projecthelp",
  "userhelp",
  "mobilehelp",
  "modelfunction",
];
export const enterpriseRoute = [
  "enterprisemanagement",
  "enterpriseproject",
  "projectsheet",
  "enterprisemodelmanagement",
  "enterprisepersonnel",
  "smartbigdata",
  "operationinfo",
];
export const projectRoute = [
  "projectinformation",
  "informmanagement",
  "jobpage",
  "sessionpage",
  "organization",
  "usermanagement",
  "postpermissions",
  "singleset",
  "formtemplate",
  "chartflow",
  "topic",
  "coordinate",
  "contactList",
  "security",
  "construction",
  "datadirectory",
  "template",
  "tagsetting",
  "flowlayout",
  "modelconfigure",
  "dataquery",
];

router.beforeEach((to, from, next) => {
  if (to.name == null) {
    next({
      path: "/error404",
    });
  }
  if (
    to.name.toLowerCase() == "screentic" ||
    to.name.toLowerCase() == "viewmodel" ||
    to.name.toLowerCase() == "appmodelview" ||
    to.name.toLowerCase() == "appdocumentshow" ||
    to.name.toLowerCase() == "appdrawingshow"
  ) {
    //pc端不需要token
    next();
  } else if (to.name.toLowerCase() != "login") {
    //pc端
    if (!localStorage.getItem("token")) {
      next({
        path: "/login",
      });
    } else {
      GetUserByToken().then((res) => {
        if (res.Data) {
          store.state.uid = localStorage.id = res.Data.user01;
          if (res.Data.user13)
            store.state.UserImgs = store.state.baseUrl + res.Data.user13;
          else store.state.userImgs = "";
        }
      });
      if (to.name.toLowerCase() == "enterpriseindex") {
        IsAdmin().then((res) => {
          if (res.Data) {
            next({
              path: "/adminUser",
            });
          }
        });
      }
      if (enterpriseRoute.indexOf(to.name.toLowerCase()) >= 0) {
        IsEnterprise({
          pid: localStorage.pid,
        }).then((res) => {
          if (res.Data) {
            next();
          } else {
            next({
              path: "/error404",
            });
          }
        });
      } else if (adminRoute.indexOf(to.name.toLowerCase()) >= 0) {
        IsAdmin().then((res) => {
          if (res.Data) {
            next();
          } else {
            next({
              path: "/error404",
            });
          }
        });
      } else if (projectRoute.indexOf(to.name.toLowerCase()) >= 0) {
        IsProject({
          xid: localStorage.xid,
        }).then((res) => {
          if (res.Data) {
            next();
          } else {
            next({
              path: "/error404",
            });
          }
        });
      } else {
        next();
      }
    }
  } else {
    //有token跳login
    if (!localStorage.getItem("token")) {
      next();
    } else {
      next({
        path: from.name,
      });
    }
  }
});

export default router;
